import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-info_warring",
  "use": "icon-info_warring-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-info_warring\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M11.1,7.94h1.8V9.75H11.1Zm0,8.12h1.8v-5H11.1ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm6.2-8A6.2,6.2,0,1,0,12,18.2,6.21,6.21,0,0,0,18.2,12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol